import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Linkedin, Instagram, Mail, Phone } from 'lucide-react';
import { BillvastLogo } from '../ui/BillvastLogo';
export const Footer: React.FC = () => {
  return <footer className="bg-white border-t border-gray-100 pt-16 pb-8" data-id="element-75">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-77">
          <div className="col-span-1 md:col-span-2" data-id="element-78">
            <Link to="/" className="inline-flex mb-4" data-id="element-79">
              <BillvastLogo size="md" data-id="element-80" />
            </Link>
            <p className="text-brand-text-light mb-6 max-w-sm" data-id="element-81">
              Your Finances. Premium Relief. Manage your entire financial life
              on one seamless platform.
            </p>
            <div className="flex gap-4" data-id="element-82">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-500 hover:bg-brand-primary hover:text-white transition-colors" data-id="element-83">
                <Twitter size={18} data-id="element-84" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-500 hover:bg-brand-primary hover:text-white transition-colors" data-id="element-85">
                <Linkedin size={18} data-id="element-86" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-500 hover:bg-brand-primary hover:text-white transition-colors" data-id="element-87">
                <Instagram size={18} data-id="element-88" />
              </a>
            </div>
          </div>

          <div data-id="element-89">
            <h4 className="font-bold text-brand-text-dark mb-4" data-id="element-90">Legal</h4>
            <ul className="space-y-3" data-id="element-91">
              <li data-id="element-92">
                <a href="#" className="text-brand-text-light hover:text-brand-primary transition-colors" data-id="element-93">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-94">
                <a href="#" className="text-brand-text-light hover:text-brand-primary transition-colors" data-id="element-95">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-96">
            <h4 className="font-bold text-brand-text-dark mb-4" data-id="element-97">Contact</h4>
            <ul className="space-y-3" data-id="element-98">
              <li data-id="element-99">
                <a href="mailto:info@billvast.com" className="text-brand-text-light hover:text-brand-primary transition-colors flex items-center gap-2" data-id="element-100">
                  <Mail size={16} data-id="element-101" /> info@billvast.com
                </a>
              </li>
              <li data-id="element-102">
                <a href="tel:+2348070709966" className="text-brand-text-light hover:text-brand-primary transition-colors flex items-center gap-2" data-id="element-103">
                  <Phone size={16} data-id="element-104" /> +2348070709966
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-100 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-105">
          <p className="text-brand-text-light text-sm" data-id="element-106">
            © 2026 Billvast. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};